import React, { useEffect, useRef } from "react";
import {
  Button,
  FormField,
  Select,
  SelectProps,
} from "@amzn/awsui-components-react";

export default function OMSColumnMove({
  name,
  names,
  onMove,
  onCancel,
}: {
  name: string;
  names: string[];
  onMove: (position: number) => void;
  onCancel: () => void;
}) {
  const control = useRef<SelectProps.Ref>(null);
  const remaining = names.filter((item) => item !== name);
  useEffect(() => {
    control.current?.focus();
  }, []);
  return (
    <div className="oms-columns__move">
      <FormField label={`Move ${name}`}>
        <Select
          ref={control}
          expandToViewport
          ariaLabel={`Destination for ${name}`}
          filteringType="auto"
          filteringPlaceholder="Find a destination column"
          filteringAriaLabel="Find a destination column"
          selectedOption={null}
          placeholder="Choose where to place this column"
          options={[
            ...remaining.map((item) => ({
              value: `before:${item}`,
              label: `Before ${item}`,
            })),
            { value: "end", label: "End of CSV" },
          ]}
          onChange={({ detail }) => {
            const { value } = detail.selectedOption;
            const position =
              value === "end"
                ? remaining.length + 1
                : remaining.indexOf(value?.slice(7) || "") + 1;
            if (position > 0) onMove(position);
          }}
          noMatch="No matching destination."
        />
      </FormField>
      <Button onClick={onCancel}>Cancel move</Button>
    </div>
  );
}
